import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';

function HeaderNavigation({ sx, children }) {
    return jsx(Wrapper, { sx: sx, children: children });
}
const Wrapper = styled("nav")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(1),
    flexGrow: 1,
}));

export { HeaderNavigation };
//# sourceMappingURL=Navigation.js.map
